import { isDefined } from "./lang";
export var Strings;
(function (Strings) {
    Strings.hyphenToCamelCase = (value) => value
        .replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    Strings.nonEmpty = (str) => isDefined(str) && str.trim().length > 0;
    Strings.fallback = (value, fallback) => Strings.nonEmpty(value) ? value : fallback;
    Strings.endsWithDigit = (str) => /\d$/.test(str);
    // UTF-8
    Strings.toArrayBuffer = (str) => {
        const buffer = new ArrayBuffer(str.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < str.length; i++) {
            view[i] = str.charCodeAt(i);
        }
        return buffer;
    };
    // Returns desiredName if free, otherwise appends/increments a numeric suffix
    // until unique. A trailing " <number>" in desiredName is treated as the
    // counter, so getUniqueName(["Foo 2"], "Foo 2") yields "Foo 3", not "Foo 2 2".
    Strings.getUniqueName = (existingNames, desiredName) => {
        const existing = new Set(existingNames);
        if (!existing.has(desiredName)) {
            return desiredName;
        }
        const match = desiredName.match(/^(.*\S)\s+(\d+)$/);
        const base = isDefined(match) ? match[1] : desiredName;
        let counter = isDefined(match) ? parseInt(match[2], 10) + 1 : 2;
        let candidate = `${base} ${counter}`;
        while (existing.has(candidate)) {
            candidate = `${base} ${++counter}`;
        }
        return candidate;
    };
})(Strings || (Strings = {}));
